import React, { Component } from "react";
import { JobWarning } from "../../../../../common/api/v1.1/types/jobs";

import { StateCallbacks } from "../../state";
import { Block, State, TaxonomyEntry, TaxonomyEntryType } from "../../types";
import { GroupQuestion } from "./GroupQuestion";
import { Question as DataPointQuestion } from "./Question";

type Props = Readonly<{
  active: State["activeValue"];
  confidenceThreshold: State["confidenceThreshold"];
  taxonomyEntry: TaxonomyEntry;
  review: boolean;
  stateCallbacks: StateCallbacks;
  taxonomy: State["taxonomy"];
  values: State["values"];
  blocks: {
    [blockId: string]: Block;
  };
  focusWarningsTab: () => void;
  warnings: JobWarning[];
}>;

export class Question extends Component<Props> {
  public displayName = "Question";

  public shouldComponentUpdate(nextProps: Props): boolean {
    if (
      nextProps.confidenceThreshold !== this.props.confidenceThreshold ||
      nextProps.taxonomyEntry !== this.props.taxonomyEntry ||
      nextProps.review !== this.props.review ||
      nextProps.stateCallbacks !== this.props.stateCallbacks ||
      nextProps.taxonomy !== this.props.taxonomy ||
      // change in blocks could affect the red highlighting for mismatches
      nextProps.blocks !== this.props.blocks 
    ) {
      return true;
    }
    const taxonomyEntry = this.props.taxonomyEntry;
    // create a "matches" method to determine if any of the value keys matches this data point
    /*const matches =
      taxonomyEntry.type === TaxonomyEntryType.Group || taxonomyEntry.multiple
        ? // for groups or multiple data points, we use a prefix
          (str: string): boolean => str.startsWith(`${this.props.dataPoint.key}.`)
        : // for singular data points outside of groups, we use an exact match
          (str: string): boolean => str === this.props.dataPoint.key;
    if (
      nextProps.active !== this.props.active &&
      (matches(nextProps.active) || matches(this.props.active))
    ) {
      return true;
    }*/
    // const oldRelevantKeys = Object.keys(this.props.values).filter(matches);
    // const newRelevantKeys = Object.keys(nextProps.values).filter(matches);
    // if (oldRelevantKeys.length !== newRelevantKeys.length) {
    //   return true;
    // }
    // for (let i = 0; i < oldRelevantKeys.length; i++) {
    //   if (
    //     oldRelevantKeys[i] !== newRelevantKeys[i] ||
    //     this.props.values[oldRelevantKeys[i]] !== nextProps.values[newRelevantKeys[i]]
    //   ) {
    //     return true;
    //   }
    // }
    return true;
  }

  public render() {
    const {
      active,
      confidenceThreshold,
      taxonomyEntry,
      review,
      stateCallbacks,
      taxonomy,
      values,
      blocks,
      focusWarningsTab,
      warnings
    } = this.props;
    let contents = null;
    if (taxonomyEntry.type === TaxonomyEntryType.Group) {
      contents = (
        <GroupQuestion
          active={active}
          confidenceThreshold={confidenceThreshold}
          group={taxonomyEntry}
          review={review}
          stateCallbacks={stateCallbacks}
          taxonomy={taxonomy}
          values={values}
          blocks={blocks}
          focusWarningsTab={focusWarningsTab}
          warnings={warnings}
        />
      );
    } else {
      contents = (
        <DataPointQuestion
          active={active}
          confidenceThreshold={confidenceThreshold}
          dataPoint={taxonomyEntry}
          review={review}
          stateCallbacks={stateCallbacks}
          values={values}
          blocks={blocks}
          focusWarningsTab={focusWarningsTab}
          warnings={warnings}
        />
      );
    }
    return (
      <div className="question" id={`question-${taxonomyEntry.id}`}>
        {contents}
      </div>
    );
  }
}
